<template>
  <tela-component title="Pedidos Realizados - Veterinária">
    <v-card flat rounded="lg">
      <v-card-text>
        <v-progress-linear v-if="loading"></v-progress-linear>
        <template v-else>
          <v-select
            label="Vendedor"
            :items="getVendedoresFiltrados()"
            item-text="nome"
            item-value="codigo"
            v-model="vendedorSelec"
          ></v-select>
          <v-row dense>
            <v-col xl="6" lg="6" md="6" cols="12">
              <v-text-field
                label="Data inicial"
                type="date"
                v-model="dtini"
              ></v-text-field>
            </v-col>
            <v-col xl="6" lg="6" md="6" cols="12">
              <v-text-field
                label="Data final"
                type="date"
                v-model="dtfim"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-select
                label="Situação pedido"
                hide-details=""
                :items="situacoesPed"
                v-model="situacaoSelec"
              ></v-select>
            </v-col>
          </v-row>
          <v-btn
            rounded
            block
            color="info"
            depressed
            @click="gerarRelatorio()"
            class="mt-6"
            >Gerar Relatório</v-btn
          >
        </template>
      </v-card-text>
    </v-card>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  components: { TelaComponent },
  computed: {
    ...mapState("usuario", ["usuarioLogado"]),
    ...mapState("base", ["vendedores"]),
  },
  data: () => ({
    loading: true,
    vendedorSelec: 0,
    dtini: moment().startOf("month").format("YYYY-MM-DD"),
    dtfim: moment().format("YYYY-MM-DD"),
    situacaoSelec: 0,
    situacoesPed: [
      { text: "TODOS", value: 0 },
      { text: "PENDENTES", value: 1 },
      { text: "FATURADOS", value: 2 },
    ],
  }),
  methods: {
    ...mapActions("base", ["getVendedores"]),
    gerarRelatorio() {
      const urlRelat = `${process.env.VUE_APP_BASE_URL}/nutricao-animal/relatorios/veterinaria?token=${this.usuarioLogado.token}&relat=PEDIDOS&cod_vendedor=${this.vendedorSelec}&dtini=${this.dtini}&dtfim=${this.dtfim}&situacao=${this.situacaoSelec}`;
      window.open(urlRelat, "_blank");
    },
    getVendedoresFiltrados() {
      return this.vendedores.filter(
        (v) => v.vendedor_coasul_ext && v.codigo > 0
      );
    },
  },
  async mounted() {
    this.loading = true;
    await this.getVendedores();
    this.vendedorSelec = this.getVendedoresFiltrados()[0].codigo;
    this.loading = false;
  },
};
</script>

<style>
</style>